import { PaymentPackage } from "@scrile/api-provider/dist/api/PaymentPackageProvider";
import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import {
  formatMoneyString as formatMoneyStringLib,
  formatMoney as formatMoneyLib,
  getCreditCurrencyEqlCode,
} from "@scrile/tools/dist/lib/MoneyHelpers";
import store from "@/store";
import { $t } from "@/lib/i18nHelpers";
import { getLocale } from "@/lib/localeHelper";
import config from "@/config";

export { getCurrencySymbol } from "@scrile/tools/dist/lib/MoneyHelpers";

export function getCurrencyCode() {
  return getCreditCurrencyEqlCode();
}

export function getMainCurrencyCode() {
  return store.state.systemSettings?.mainCurrency ?? "USD";
}

interface FormatMoneyOpts {
  currencyCode?: string;
  forceNumberSymbol?: boolean;
  minimumFractionDigits?: number;
}

export function formatMoney(
  amount: number,
  {
    currencyCode = getCurrencyCode(),
    forceNumberSymbol = false,
    minimumFractionDigits = config.FRACTIONAL_PART_LENGTH,
  }: FormatMoneyOpts = {}
) {
  return formatMoneyLib(amount, {
    currencyCode: currencyCode,
    locale: getLocale(),
    creditsSymbolTranslator: $t,
    useGrouping: config.moneyUseGrouping,
    forceNumberSymbol,
    minimumFractionDigits,
  });
}

export function formatMoneyString(
  amount: number,
  {
    currencyCode = getCurrencyCode(),
    forceNumberSymbol = false,
    minimumFractionDigits = config.FRACTIONAL_PART_LENGTH,
  }: FormatMoneyOpts = {}
) {
  return formatMoneyStringLib(amount, {
    currencyCode,
    locale: getLocale(),
    creditsSymbolTranslator: $t,
    useGrouping: config.moneyUseGrouping,
    forceNumberSymbol,
    minimumFractionDigits,
  });
}

export function getCost(pricePackage: PaymentPackage): number {
  return pricePackage.amount;
}

export function getCurrentPaymentSystem(systems: PaymentSystemPublic[], currency: string) {
  const system = systems.find(publicSystem => publicSystem.currencies.includes(currency));
  if (!system) throw new Error("System not found");
  return system;
}

export function getShrinkedNumber(value: number): string {
  if (value > 999999) return `${Math.floor(value / 1000000)}M`;
  if (value > 999) return `${Math.floor(value / 1000)}K`;
  return `${value}`;
}

export function printPaymentPackageName(name: string) {
  return name ? `${name}, ` : "";
}

export function printPaymentPackage(paymentPackage: PaymentPackage) {
  return `${printPaymentPackageName(paymentPackage.name)}${formatMoneyString(paymentPackage.amount)}`;
}

export function getCostByCurrency(p: PaymentPackage, currency: string = getMainCurrencyCode()) {
  return p.costs.find(i => i.currency === currency);
}
